import { Box } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';

export const SizedBox = styled(Box, {
  width: '64px',
  height: '64px',

  variants: {
    backgroundColor: {
      backgroundDark: {
        backgroundColor: '$backgroundDark',
      },
      feedbackError: {
        backgroundColor: '$feedbackError',
      },
      feedbackSuccess: {
        backgroundColor: '$feedbackSuccess',
      },
      feedbackWarning: {
        backgroundColor: '$feedbackWarning',
      },
    },
  },
});
